// Exported separately so tests can verify token classes without importing Base UI.
export const DIALOG_BACKDROP_CLASS =
  'fixed inset-0 z-50 bg-background/80 backdrop-blur-sm data-[ending-style]:opacity-0 data-[starting-style]:opacity-0 transition-opacity duration-150';

export const DIALOG_POPUP_CLASS =
  'fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border border-border bg-card p-6 shadow-lg duration-200 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0 sm:rounded-lg';
